import { useEffect, useRef } from 'react';
import { useRealtime } from '../contexts/RealtimeContext';

/**
 * Recarrega a tela quando a API publica um evento nos tópicos dados.
 * `paused` evita sobrescrever um formulário aberto.
 */
export function useRealtimeRefresh(topics, onRefresh, options = {}) {
  const { subscribe } = useRealtime();
  const onRefreshRef = useRef(onRefresh);
  const pausedRef = useRef(!!options.paused);
  const timerRef = useRef(null);
  const debounceMs = options.debounceMs ?? 600;

  onRefreshRef.current = onRefresh;
  pausedRef.current = !!options.paused;

  const topicsKey = Array.isArray(topics) ? topics.join(',') : String(topics || '');

  useEffect(() => {
    if (options.enabled === false || !topicsKey) return undefined;

    const list = topicsKey.split(',').filter(Boolean);
    return subscribe(list, () => {
      if (pausedRef.current) return;
      if (timerRef.current) window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => {
        timerRef.current = null;
        onRefreshRef.current?.();
      }, debounceMs);
    });
  }, [subscribe, topicsKey, debounceMs, options.enabled]);

  useEffect(
    () => () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    },
    []
  );
}
